jQuery(function ($) {
    $(document).ready(function() {
        //to prevent hiding footer add extra margin to it for sticky subscription block 
        if( $( '.sidebar-subscription-block' ).length && $(window).width() < 992) {
            $elHeight = $('.sidebar-subscription-block').outerHeight();
            $('#footer').css('margin-bottom', $elHeight);
        }
    });
});